import { FC } from 'react';
import { useFragment, graphql } from 'react-relay';
import { FormattedMessage } from 'dibs-react-intl';

import { DealerLocation_item$key } from './__generated__/DealerLocation_item.graphql';

type Props = {
    item: DealerLocation_item$key | null;
};

const DealerLocation: FC<Props> = ({ item: itemRef }) => {
    const item = useFragment(
        graphql`
            fragment DealerLocation_item on Item {
                vertical
                address {
                    displayCityStateCountry
                }
            }
        `,
        itemRef
    );
    const location = item?.address?.displayCityStateCountry;

    return (
        <FormattedMessage
            id="checkout.DealerLocation.description"
            defaultMessage="The {vertical, select, art {gallery} other {seller}} is located in {location}."
            values={{
                vertical: item?.vertical,
                location,
            }}
        />
    );
};

export default DealerLocation;
